/**
 * Warns about ACTIVE StockX sneaker rows without the SNEAKERS tag. Boxed reads that tag to show
 * the size step and to put the chosen size on the order line, so each of these sells as a
 * non-sneaker until the daily refresh adds the tag, or a promote writes the row again.
 */
export function UntaggedSneakersAlert({ count, ids }: { count: number; ids: string[] }) {
  return (
    <div className="rounded-md border border-amber-500/50 bg-amber-500/10 px-3 py-2 text-sm">
      <p>
        {count} active StockX sneaker {count === 1 ? "row has" : "rows have"} no SNEAKERS tag, so
        Boxed sells {count === 1 ? "it" : "them"} with no size step. The next refresh or promote
        adds the tag.
      </p>
      <ul className="mt-1 font-mono text-xs text-muted-foreground">
        {ids.map((id) => (
          <li key={id}>{id}</li>
        ))}
        {count > ids.length && <li>and {count - ids.length} more</li>}
      </ul>
    </div>
  );
}
